
import { TableListHeader } from '@/models/main';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class TableList extends Vue {
  @Prop({ type: Array, required: true }) public headers: TableListHeader[];
  @Prop({ type: Array, required: true }) public items: [];
}
